import config from "../config";

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 
            'Authorization': 'Bearer ' + user.token,
            'x-api-key': user.username, };
    } else {
        return {};
    }
}

export function authChallengeHeader(){
    return {'x-api-key': config.CHALLENGE_X_API_KEY}
}